import PropTypes from 'prop-types';

var optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

export { optionPropType as default, optionPropType };
//# sourceMappingURL=dropdownPropTypes.js.map
